import http from "../utils/http";
import { toast } from "../utils/toast";

// 출퇴근 장소 목록
export const getWorkPlacesList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/places/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 출퇴근 장소 등록
export const createWorkPlaces = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/work/places", body)
      .then((res) => {
        toast.success("출퇴근 장소가 등록되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 출퇴근 장소 수정
export const updateWorkPlacesList = (placeIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/work/places/${placeIdx}`, body)
      .then((res) => {
        toast.success("출퇴근 장소가 수정되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 출퇴근 장소 삭제
export const deleteWorkPlacesList = (placeIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/work/places/${placeIdx}`)
      .then((res) => {
        toast.success("출퇴근 장소가 삭제되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
